import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import UserBalanceHistoryModal from "../../modals/UserBalanceHistoryModal.vue";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    components: {
        UserBalanceHistoryModal
    },
    data() {
        return {
            locale: LocService,
            loading: false,
            filter: '',
            users: [],
            filterDebounceTimer: null,
            showBalanceHistory: false,
            selectedBalanceUser: null,
            balanceHistory: [],
            balanceHistoryPage: 1,
            balanceHistoryLimit: 20,
            balanceHistoryTotal: 0,
            isLoadingBalanceHistory: false,
            isAdjustingBalance: false,
            balanceAdjustAmount: '',
            balanceAdjustNote: ''
        }
    },
    methods: {
        loadUsersWithNonZeroBalance: loadUsersWithNonZeroBalance,
        onFilterInput: onFilterInput,
        openBalanceHistory: openBalanceHistory,
        closeBalanceHistory: closeBalanceHistory,
        loadBalanceHistory: loadBalanceHistory,
        submitBalanceAdjust: submitBalanceAdjust,
        getBalanceClass: getBalanceClass,
        formatBalanceAmount: formatBalanceAmount,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.loadUsersWithNonZeroBalance();
    },
    beforeDestroy() {
        if(this.filterDebounceTimer != null){
            clearTimeout(this.filterDebounceTimer);
            this.filterDebounceTimer = null;
        }
    }
}

function onFilterInput(){
    if(this.filterDebounceTimer != null){
        clearTimeout(this.filterDebounceTimer);
        this.filterDebounceTimer = null;
    }
    this.filterDebounceTimer = setTimeout(() => {
        this.loadUsersWithNonZeroBalance();
    }, 300);
}

function loadUsersWithNonZeroBalance(){
    this.loading = true;
    const filterValue = this.filter != null && this.filter.trim().length > 0 ? this.filter.trim() : null;

    AdminApiService.getUsersWithNonZeroBalance(filterValue)
        .then((response) => {
            this.users = response.data || [];
            this.loading = false;
        })
        .catch((error) => {
            this.loading = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error');
        });
}

function openBalanceHistory(user){
    if(user == null) return;
    this.selectedBalanceUser = user;
    this.showBalanceHistory = true;
    this.balanceHistoryPage = 1;
    this.balanceAdjustAmount = '';
    this.balanceAdjustNote = '';
    this.loadBalanceHistory(1);
}

function closeBalanceHistory(){
    this.showBalanceHistory = false;
    this.selectedBalanceUser = null;
    this.balanceHistory = [];
    this.balanceHistoryTotal = 0;
    this.balanceAdjustAmount = '';
    this.balanceAdjustNote = '';
}

function loadBalanceHistory(page){
    if(this.selectedBalanceUser == null) return;
    const pageToLoad = page != null ? page : this.balanceHistoryPage;
    if(pageToLoad < 1) return;

    this.isLoadingBalanceHistory = true;
    AdminApiService.getUserBalanceHistory(this.selectedBalanceUser.id, pageToLoad, this.balanceHistoryLimit)
        .then((response) => {
            this.balanceHistory = response.data.results || [];
            this.balanceHistoryTotal = response.data.totalCount || 0;
            this.balanceHistoryPage = pageToLoad;
            this.isLoadingBalanceHistory = false;
        })
        .catch((error) => {
            this.isLoadingBalanceHistory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error');
        });
}

function submitBalanceAdjust(direction){
    if(this.selectedBalanceUser == null) return;
    if(this.isAdjustingBalance) return;

    const raw = ('' + this.balanceAdjustAmount).trim();
    if(raw.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_balance_amount_required'), 'error');
        return;
    }
    if(!/^-?\d+(\.\d{1,2})?$/.test(raw)){
        swal(LocService.t('label_error'), LocService.t('label_balance_amount_invalid'), 'error');
        return;
    }

    const parsed = parseFloat(raw);
    if(!Number.isFinite(parsed) || parsed === 0){
        swal(LocService.t('label_error'), LocService.t('label_balance_amount_zero'), 'error');
        return;
    }

    if(this.balanceAdjustNote == null || this.balanceAdjustNote.trim().length === 0){
        swal(LocService.t('label_error'), LocService.t('label_balance_note_required'), 'error');
        return;
    }

    const absAmount = Math.abs(parsed);
    const signedAmount = direction === 'debit' ? (-1 * absAmount) : absAmount;

    const model = {
        userId: this.selectedBalanceUser.id,
        amount: signedAmount,
        note: this.balanceAdjustNote.trim()
    };

    this.isAdjustingBalance = true;
    AdminApiService.adminAdjustUserBalance(model)
        .then(() => {
            this.isAdjustingBalance = false;
            this.balanceAdjustAmount = '';
            this.balanceAdjustNote = '';
            swal(LocService.t('label_success'), LocService.t('label_balance_updated'), 'success');
            this.loadUsersWithNonZeroBalance();
            this.loadBalanceHistory(1);
        })
        .catch((error) => {
            this.isAdjustingBalance = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error');
        });
}

function getBalanceClass(amount){
    const value = parseFloat('' + (amount != null ? amount : 0));
    if(!Number.isFinite(value)) return 'is-neutral';
    if(value < 0) return 'is-negative';
    if(value > 0) return 'is-positive';
    return 'is-neutral';
}

function formatBalanceAmount(amount){
    const value = parseFloat('' + (amount != null ? amount : 0));
    if(!Number.isFinite(value)) return '0.00';
    return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}



// WEBPACK FOOTER //
// ./src/components/Report/BarSaldoDebtorsReport.js